export default {
  getDefaultState: () => {
    return {
      currentCompany: {},
      officeFormConfigurations: [],
      isCallingCompany: false,
      isFuellFrozen: false
    }
  }
}
